module.exports = __webpack_public_path__ + "img/11@2x.2dab898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/11@2x.png
// module id = G3M7
// module chunks = 0